import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dkn-admin-statuses mt-2" }
const _hoisted_2 = { class: "dkn-admin-status-header" }
const _hoisted_3 = { class: "dkn-admin-status-value" }
const _hoisted_4 = { class: "asset-stats-grid" }
const _hoisted_5 = { class: "dkn-admin-status-header" }
const _hoisted_6 = { class: "dkn-admin-status-value" }
const _hoisted_7 = {
  key: 1,
  class: "modbus-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.items.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickStatuses, (status) => {
            return (_openBlock(), _createElementBlock("div", {
              key: status.key,
              class: _normalizeClass(["dkn-admin-status", status.toneClass])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(status.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(status.label), 1)
              ]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(status.value), 1)
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-snow" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.value), 1)
            ], 2))
          }), 128))
        ])
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "bi bi-thermometer-snow" }, null, -1),
        _createElementVNode("span", null, "Brak danych chłodni", -1)
      ]))]))
}